module.exports = __webpack_public_path__ + "toGroom-we-b-b.747473a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-b-b.jpg
// module id = GzVT
// module chunks = 0